import React from "react";
import {useElementOnScreen} from "../../shared/hook/useElementOnScreen";
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import S from './Banner.module.scss';

export const Banner = () => {
  const scrollToSection = useScrollToSection();
  const [bannerRef, isVisible] = useElementOnScreen<HTMLDivElement>();

  return (
    <div className={S.banner} id='banner' ref={bannerRef}>
      <div className={`${S.elements} ${isVisible ? S.visible : ''}`}>
        <div>
          <div className={S.title}>
            ЦИФРОВИЗАЦИЯ<br/> ВАШЕГО БИЗНЕСА
          </div>
          <div className={S.titleTwo}>на основе собственной <span>low-code</span> платформы</div>
        </div>
        <div className={S.description}>
          БМК Софт разрабатывает и внедряет системы цифровизации производственных
          и бизнес-процессов для <span onClick={() => scrollToSection('industries')}>промышленных</span> и <span
          onClick={() => scrollToSection('industries')}>ИТ-компаний</span>
        </div>
        <div className={S.divButton}>
          <button onClick={() => scrollToSection('requestForm')} className={S.button}>связаться</button>
        </div>
      </div>
    </div>
  );
};
